import clientConfig from '../config';

// const API_BASE_ROOT_URL = clientConfig.apiBaseHost + clientConfig.apiBasePath;

export const getHeaders = guestCheckout => {
  // Parametri Querystring
  // "mc_cid" delle campagne MailChimp
  // e "cks" di Awin
  let mcCid = '';
  let awCks = '';
  if (process.env.BROWSER && clientConfig.useSSR) {
    mcCid = localStorage.getItem('mc_cid') || '';
    awCks = localStorage.getItem('aw_cks') || '';
  }
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    // 'storeid': clientConfig.storeId
  };
  if (mcCid) {
    headers.McCid = mcCid;
  }
  if (awCks) {
    headers.AwCks = awCks;
  }
  if (guestCheckout) {
    headers['guest-checkout'] = true;
  }
  return headers;
};

export const getAuthToken = () => {
  const token = localStorage.getItem('token');
  return token;
};

export const getAuthHeaders = guestCheckout => {
  let token = localStorage.getItem('cartToken');

  if (localStorage.getItem('token') !== null) {
    // Se utente loggato
    token = localStorage.getItem('token');
  }
  return {
    ...getHeaders(guestCheckout),
    Authorization: 'Bearer ' + token,
  };
};

export const getApiUrl = () => {
  try {
    if (!!clientConfig.useDevApi) {
      return clientConfig.devApiBaseHost + clientConfig.apiBasePath;
    } else if (typeof localStorage !== 'undefined') {
      const storeId = localStorage.getItem('storeId');
      if (!!storeId) {
        if (!!clientConfig.hostname) {
          return `https://${clientConfig.hostname}/api/${storeId}${clientConfig.apiBasePath}`;
        } else {
          return `/api/${storeId}${clientConfig.apiBasePath}`;
        }
      } else {
        return clientConfig.apiBaseHost + clientConfig.apiBasePath;
      }
    } else {
      return clientConfig.apiBaseHost + clientConfig.apiBasePath;
    }
  } catch (error) {
    return clientConfig.apiBaseHost + clientConfig.apiBasePath;
  }
};

const api = {
  ///////////////////////////////////////////////////////////
  // SESSIONS
  login: credentials => {
    return {
      endpoint: `${getApiUrl()}/account/login`,
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(credentials),
    };
  },

  loginFacebook: credentials => {
    return {
      endpoint: `${getApiUrl()}/account/login/facebook`,
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(credentials),
    };
  },

  getUser: () => {
    return {
      endpoint: `${getApiUrl()}/account`,
      method: 'GET',
      headers: getAuthHeaders(),
    };
  },

  createUser: user => {
    return {
      endpoint: `${getApiUrl()}/account/register`,
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(user),
    };
  },

  checkEmailAvailability: email => {
    return {
      endpoint: `${getApiUrl()}/check_availability?email=${email}`,
      method: 'GET',
      headers: getHeaders(),
    };
  },

  checkEmailAvailabilityEdit: email => {
    return {
      endpoint: `${getApiUrl()}/check_availability?email=${email}`,
      method: 'GET',
      headers: getAuthHeaders(),
    };
  },

  passwordReset: email => {
    return {
      endpoint: `${getApiUrl()}/account/reset`,
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({ email }),
    };
  },

  passwordChange: (token, password) => {
    return {
      endpoint: `${getApiUrl()}/account/reset`,
      method: 'PUT',
      headers: getHeaders(),
      body: JSON.stringify({ token, password }),
    };
  },

  ///////////////////////////////////////////////////////////
  // ACCOUNT

  saveAccount: (userId, userData) => {
    return {
      endpoint: `${getApiUrl()}/users/${userId}`,
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(userData),
    };
  },

  getOrders: () => {
    return {
      endpoint: `${getApiUrl()}/orders`,
      method: 'GET',
      headers: getAuthHeaders(),
    };
  },

  getOrdersCount: () => {
    return {
      endpoint: `${getApiUrl()}/orders/count`,
      method: 'GET',
      headers: getAuthHeaders(),
    };
  },

  getOrderById: (orderId, userEmail) => {
    return {
      endpoint:
        `${getApiUrl()}/orders/${orderId}` +
        (!!userEmail ? '?userEmail=' + userEmail : ''),
      method: 'GET',
      headers: getAuthHeaders(),
    };
  },

  //Carta fedelta' /////////////////////////

  getFideltyCoupons: () => {
    return {
      endpoint: `${getApiUrl()}/fidelity-card`,
      method: 'GET',
      headers: getAuthHeaders(),
    };
  },

  getActiveCoupons: () => {
    return {
      endpoint: `${getApiUrl()}/fidelity-card/get-user-coupons`,
      method: 'GET',
      headers: getAuthHeaders(),
    };
  },

  getFideltyPoints: () => {
    return {
      endpoint: `${getApiUrl()}/fidelity-card/point`,
      method: 'GET',
      headers: getAuthHeaders(),
    };
  },

  insertFidelityCoupon: couponId => {
    return {
      url: `${getApiUrl()}/fidelity-card?fidelityCouponId=${couponId}`,
      method: 'PUT',
      headers: getAuthHeaders(),
    };
  },

  ////////////////////////////////////////////

  printInvoice: orderId => {
    return {
      endpoint: `${getApiUrl()}/orders/${orderId}/invoice`,
      method: 'GET',
      headers: getAuthHeaders(),
    };
  },

  printCreditMemo: orderId => {
    return {
      endpoint: `${getApiUrl()}/orders/${orderId}/credit_memo`,
      method: 'GET',
      headers: getAuthHeaders(),
    };
  },

  payLater: (orderId, paymentTypeName) => {
    return {
      endpoint: `${getApiUrl()}/payments/${paymentTypeName}/pay`,
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({ orderId }),
    };
  },

  ///////////////////////////////////////////////////////////
  // NEWSLETTER

  saveNewsletter: email => {
    return {
      endpoint: `${getApiUrl()}/newsletter`,
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({ email }),
    };
  },

  ///////////////////////////////////////////////////////////
  // STORE

  getStore: () => {
    return {
      endpoint: `${getApiUrl()}/store`,
      method: 'GET',
      headers: getHeaders(),
    };
  },

  ///////////////////////////////////////////////////////////
  // COMUNI

  getCities: (query, limit) => {
    return {
      endpoint: `${getApiUrl()}/cities?q=${query}&limit=${limit}`,
      method: 'GET',
      headers: getHeaders(),
    };
  },

  ///////////////////////////////////////////////////////////
  // NAZIONI

  getCountries: () => {
    return {
      endpoint: `${getApiUrl()}/countries`,
      method: 'GET',
      headers: getHeaders(),
    };
  },

  ///////////////////////////////////////////////////////////
  // PUDO

  getPudos: address => {
    return {
      endpoint: `${getApiUrl()}/shippings/get-pudo-by-address`,
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(address),
    };
  },

  ///////////////////////////////////////////////////////////
  // BLOG

  // Tutti i post
  getPosts: (page = 1, pageSize = 10) => {
    return {
      endpoint: `${getApiUrl()}/posts?page=${page}&pageSize=${pageSize}`,
      method: 'GET',
      headers: getHeaders(),
    };
  },

  // Single post
  getPost: postId => {
    return {
      endpoint: `${getApiUrl()}/posts/${postId}`,
      method: 'GET',
      headers: getHeaders(),
    };
  },

  ///////////////////////////////////////////////////////////
  // PAGINE

  // Single page
  getPages: () => {
    return {
      endpoint: `${getApiUrl()}/pages`,
      method: 'GET',
      headers: getHeaders(),
    };
  },

  // Single page
  getPageBySlug: pageSlug => {
    return {
      endpoint: `${getApiUrl()}/pages/${pageSlug}`,
      method: 'GET',
      headers: getHeaders(),
    };
  },

  ///////////////////////////////////////////////////////////
  // PRODOTTI HOME

  getHomeProducts: () => {
    return {
      endpoint: `${getApiUrl()}/home`,
      method: 'GET',
      headers: getHeaders(),
    };
  },

  ///////////////////////////////////////////////////////////
  // CATEGORIE

  getCategories: () => {
    return {
      endpoint: `${getApiUrl()}/categories`,
      method: 'GET',
      headers: getHeaders(),
    };
  },

  ///////////////////////////////////////////////////////////
  // TAGS

  getTags: () => {
    return {
      endpoint: `${getApiUrl()}/tags?pageSize=100`,
      method: 'GET',
      headers: getHeaders(),
    };
  },

  ///////////////////////////////////////////////////////////
  // SINTOMI

  getSymptoms: () => {
    return {
      endpoint: `${getApiUrl()}/symptoms`,
      method: 'GET',
      headers: getAuthHeaders(),
    };
  },

  ///////////////////////////////////////////////////////////
  // PRODOTTI

  // Per categoria
  getProductsByCategory: (category, page = 1, sort = '-sales') => {
    return {
      endpoint: `${getApiUrl()}/categories/${category}/products?page=${page}&sort=${sort}`,
      method: 'GET',
      headers: getHeaders(),
    };
  },

  // Per parole chiave
  getProductsByKeywords: (
    keywords,
    page = 1,
    pageSize = 21,
    sort = '-sales'
  ) => {
    return {
      endpoint: `${getApiUrl()}/products?q=${encodeURIComponent(
        keywords
      )}&page=${page}&pageSize=${pageSize}&sort=${sort}`,
      method: 'GET',
      headers: getHeaders(),
    };
  },

  // Per parole chiave
  searchProductsByKeywords: (keywords, page = 1, pageSize = 4) => {
    return {
      endpoint: `${getApiUrl()}/products_search?q=${encodeURIComponent(
        keywords
      )}&page=${page}&pageSize=${pageSize}`,
      method: 'GET',
      headers: getHeaders(),
    };
  },

  // Per parole chiave Doofinder
  getProductsByKeywordsDoofinder: (
    keywords,
    page = 1,
    pageSize = 4,
    doofinderHashId
  ) => {
    return {
      endpoint: `https://eu1-search.doofinder.com/5/search?hashid=${doofinderHashId}&query=${encodeURIComponent(
        keywords
      )}&page=${page}&rpp=${pageSize}`,
      method: 'GET',
      headers: getHeaders(),
    };
  },

  // In offerta
  getProductsDiscounted: (page = 1, pageSize = 21, sort = '-sales') => {
    return {
      endpoint: `${getApiUrl()}/products?isDiscounted=true&page=${page}&pageSize=${pageSize}&sort=${sort}`,
      method: 'GET',
      headers: getHeaders(),
    };
  },

  //

  // Per marca
  getProductgetProductsByBrand: (
    brand,
    page = 1,
    pageSize = 21,
    sort = '-sales'
  ) => {
    return {
      endpoint: `${getApiUrl()}/brands/${brand}/products?page=${page}&pageSize=${pageSize}&sort=${sort}`,
      method: 'GET',
      headers: getHeaders(),
    };
  },

  // Per sintomo
  getProductgetProductsBySymptom: (
    symptom,
    page = 1,
    pageSize = 21,
    sort = '-sales'
  ) => {
    return {
      endpoint: `${getApiUrl()}/symptoms/${symptom}/products?page=${page}&pageSize=${pageSize}&sort=${sort}`,
      method: 'GET',
      headers: getHeaders(),
    };
  },

  // Prodotti per calculated sales
  getProductsByCalculatedSales: (page = 1, pageSize = 12, sort = '-sales') => {
    return {
      endpoint: `${getApiUrl()}/products/most-sold?page=${page}&pageSize=${pageSize}&sort=${sort}&type=prodotti`,
      method: 'GET',
      headers: getHeaders(),
    };
  },
  // Farmaci per calculated sales
  getDrugsByCalculatedSales: (page = 1, pageSize = 12, sort = '-sales') => {
    return {
      endpoint: `${getApiUrl()}/products/most-sold?page=${page}&pageSize=${pageSize}&sort=${sort}&type=farmaci`,
      method: 'GET',
      headers: getHeaders(),
    };
  },

  // Per tag
  getProductsByTag: (tag, page = 1, pageSize = 21, sort = '-sales') => {
    return {
      endpoint: `${getApiUrl()}/tags/${tag}/products?page=${page}&pageSize=${pageSize}&sort=${sort}`,
      method: 'GET',
      headers: getHeaders(),
    };
  },

  // Per tag di cateogira
  getProductsByTagCategory: (tag, page = 1, pageSize = 21, sort = '-sales') => {
    return {
      endpoint: `${getApiUrl()}/category_tags/${tag}/products?page=${page}&pageSize=${pageSize}&sort=${sort}`,
      method: 'GET',
      headers: getHeaders(),
    };
  },

  ///////////////////////////////////////////////////////////
  // PRODOTTO SINGOLO
  getProductBySeoName: seoName => {
    const encodedSeoName = encodeURIComponent(seoName);
    return {
      endpoint: `${getApiUrl()}/products/${encodedSeoName}`,
      method: 'GET',
      headers: getHeaders(),
    };
  },

  getProductPriceBySeoName: seoName => {
    const encodedSeoName = encodeURIComponent(seoName);
    return {
      endpoint: `${getApiUrl()}/prices/${encodedSeoName}`,
      method: 'GET',
      headers: getHeaders(),
    };
  },

  getSimilarProductsBySeoName: seoName => {
    const encodedSeoName = encodeURIComponent(seoName);
    return {
      endpoint: `${getApiUrl()}/products/${encodedSeoName}/similars`,
      method: 'GET',
      headers: getHeaders(),
    };
  },

  getBoughtTogetherProductsBySeoName: seoName => {
    const encodedSeoName = encodeURIComponent(seoName);
    return {
      endpoint: `${getApiUrl()}/products/${encodedSeoName}/bought_together`,
      method: 'GET',
      headers: getHeaders(),
    };
  },

  getFreeProductsById: productId => {
    return {
      endpoint: `${getApiUrl()}/products/${productId}/free_products`,
      method: 'GET',
      headers: getHeaders(),
    };
  },

  ///////////////////////////////////////////////////////////
  // CARRELLO

  createCart: () => {
    return {
      endpoint: `${getApiUrl()}/carts`,
      method: 'POST',
      headers: getAuthHeaders(),
    };
  },

  getCart: cartId => {
    return {
      endpoint: `${getApiUrl()}/carts/${cartId}`,
      method: 'GET',
      headers: getAuthHeaders(),
    };
  },

  addProductToCart: (cartId, productId, quantity) => {
    return {
      endpoint: `${getApiUrl()}/carts/${cartId}/products`,
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        productId,
        quantity,
      }),
    };
  },

  removeProductFromCart: (cartId, productId) => {
    return {
      endpoint: `${getApiUrl()}/carts/${cartId}/products/${productId}`,
      method: 'DELETE',
      headers: getAuthHeaders(),
    };
  },

  updateCartQuantity: (cartId, productId, quantity) => {
    return {
      endpoint: `${getApiUrl()}/carts/${cartId}/products/${productId}`,
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        quantity,
      }),
    };
  },

  checkStockCart: cartId => {
    return {
      endpoint: `${getApiUrl()}/carts/${cartId}/check-stock`,
      method: 'GET',
      headers: getAuthHeaders(),
    };
  },

  ///////////////////////////////////////////////////////////
  // COUPON INVITA UN AMICO

  createCoupon: coupon => {
    return {
      endpoint: `${getApiUrl()}/coupons`,
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(coupon),
    };
  },

  loadUserCoupons: () => {
    return {
      endpoint: `${getApiUrl()}/coupons/get-user-coupons`,
      method: 'GET',
      headers: getAuthHeaders(),
    };
  },

  ///////////////////////////////////////////////////////////
  // CHECKOUT

  getCoupon: (couponCode, cartId) => {
    const encodedCouponCode = encodeURIComponent(couponCode);
    return {
      endpoint: `${getApiUrl()}/coupons/${encodedCouponCode}?cartId=${cartId}`,
      method: 'GET',
      headers: getAuthHeaders(),
    };
  },

  getShippingCost: (cartId, zipcode, country) => {
    const queryParmams = [];

    if (zipcode) {
      queryParmams.push(`zipcode=${zipcode}`);
    }

    if (country) {
      queryParmams.push(`country=${country}`);
    }

    return {
      endpoint: `${getApiUrl()}/carts/${cartId}/shipping_cost?${queryParmams.join(
        '&'
      )}`,
      method: 'GET',
      headers: getAuthHeaders(),
    };
  },

  createOrder: (order, guestCheckout) => {
    return {
      endpoint: `${getApiUrl()}/orders`,
      method: 'POST',
      headers: guestCheckout ? getHeaders(guestCheckout) : getAuthHeaders(),
      body: JSON.stringify(order),
    };
  },

  getEnabledCities: () => {
    return {
      endpoint: `${getApiUrl()}/cities/get-all-enabled`,
      method: 'GET',
      headers: getAuthHeaders(),
    };
  },

  geocodeAddress: address => {
    return {
      endpoint: `${getApiUrl()}/cities/geocode-address?address=${address}`,
      method: 'GET',
      headers: getAuthHeaders(),
    };
  },

  executePayment: ({ paymentID, payerID, paymentToken }) => {
    return {
      endpoint: `${getApiUrl()}/payments/paypal/execute`,
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        paymentId: paymentID,
        payerId: payerID,
        token: paymentToken,
      }),
    };
  },

  cancelPayment: ({ paymentToken }) => {
    return {
      endpoint: `${getApiUrl()}/payments/paypal/cancel`,
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        token: paymentToken,
      }),
    };
  },

  ///////////////////////////////////////////////////////////
  // SEND FORM

  sendForm: form => {
    return {
      endpoint: `${getApiUrl()}/send_form`,
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(form),
    };
  },

  sendFreshdeskForm: form => {
    return {
      endpoint: `${getApiUrl()}/send_form/freshdesk`,
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(form),
    };
  },

  /////////////////////////////////////////////////////////////////
  // RECOMMENDED ITEMS

  getRecommendedByCartId: cartId => {
    return {
      endpoint: `${getApiUrl()}/category_tags/recommended_products/${cartId}`,
      method: 'GET',
      headers: getHeaders(),
    };
  },
};

export default api;
